import { useEffect, useRef, useState } from "react";
import { createRoot } from 'react-dom/client';
import '@splidejs/react-splide/css';
import GalleryModal from 'components/shared/modal/gallery_model';
import ProductSpecificationModal from 'components/shared/modal/product_specification_modal';

export function ProductSpecification(props) {
    const [tabIdState, setTabIdState] = useState(0);
    const tabsRef = useRef(null);
    let tabs = document.getElementsByClassName('tabs')[0];
    let leftTab = document.getElementsByClassName('tab-arrow-container left')[0];
    let rightTab = document.getElementsByClassName('tab-arrow-container right')[0];
    let galleryRotatingImageData = JSON.parse(document.getElementById('rotating_images').innerHTML);
    
    window.addEventListener("resize", () => {
        if (tabs.scrollWidth === tabs.offsetWidth) {
            leftTab.style.display = 'none';
            rightTab.style.display = 'none';
        } else {
            if (tabs.scrollLeft + tabs.offsetWidth >= tabs.scrollWidth) {
                rightTab.style.display = "none";
            } else {
                rightTab.style.display = "flex";
            }
            if (tabs.scrollLeft == 0) {
                leftTab.style.display = "none";
            } else {
                leftTab.style.display = "flex";
            }
        }
    });
    
    useEffect(() => {
        if (galleryRotatingImageData && galleryRotatingImageData.length) {
            initKeyShotXR("KeyShotXR", galleryRotatingImageData[0]['rotating_image']);
            document.getElementById("expandButton").addEventListener("click",() => {
                (window as any).showGalleryModal(true, "rotate");
            });
        } else {
            // initKeyShotXR();
        }
    }, []);
    
    useEffect(() => {
        tabs = document.getElementsByClassName('tabs')[0];
        leftTab = document.getElementsByClassName('tab-arrow-container left')[0];
        rightTab = document.getElementsByClassName('tab-arrow-container right')[0];
        document.getElementsByClassName('tab-arrow-container left')[0].style.display = "none";
        
        if (tabs.scrollWidth > tabs.clientWidth) {
            rightTab.style.display = 'flex';
        }
    }, [tabsRef]);

    function rightTabClick(e) {
        tabs.scrollTo(tabs.scrollLeft+80,0);
        if (tabs.scrollLeft + tabs.offsetWidth >= tabs.scrollWidth) {
            rightTab.style.display = "none";
        }
        if (tabs.scrollLeft != 0) {
            leftTab.style.display = "flex";
        }
    }

    function leftTabClick() {
        tabs.scrollTo(tabs.scrollLeft-80,0);
        if (tabs.scrollLeft == 0) {
            leftTab.style.display = "none";
        }
        if (tabs.scrollLeft + tabs.offsetWidth < tabs.scrollWidth) {
            rightTab.style.display = "flex";
        }
    }

    return (<div className="product-specification">
        <div className="container">
            <h3>Specifications</h3>

            <div className="material-table-row">
                <div className="tab-header">
                    <div className="tab-arrow-container left" onClick={leftTabClick}>
                        <div className="tab-arrow"></div>
                    </div>
                    <div className="tab-arrow-container right" onClick={rightTabClick}>
                        <div className="tab-arrow"></div>
                    </div>
                    <div className="tabs" ref={tabsRef}>
                        <h4>{props.productLabel ? props.productLabel + ': ' : 'Material: '}</h4>
                        {props.materialSpecifications.map(function(materials, i){
                            return (
                            <>
                                <div className={'tab' + (tabIdState === i ? ' selected' : '')} onClick={() => {setTabIdState(i)}}>{materials.material.label}</div>
                            </>
                        )})}
                    </div>
                </div>
            </div>
            {props.materialSpecifications.map(function(materials, i){
                return (
                <>
                    <table style={{display: tabIdState === i ? 'block' : 'none'}}>
                        {/* <tr className="material-table-row-desktop">
                            <th>Material: </th>
                            <td>
                                <div className="tab-header">
                                    <div className="tabs">
                                        {props.materialSpecifications.map(function(materials, i){
                                            return (
                                            <>
                                                <div className={'tab' + (tabIdState === i ? ' selected' : '')} onClick={() => {setTabIdState(i)}}>{materials.material.label}</div>
                                            </>
                                        )})}
                                    </div>
                                </div>
                            </td>
                        </tr> */}
                        {
                            materials.specifications ? materials.specifications.map(function(specification, i){
                                return (
                                    <tr>
                                        <th>{specification.name}:</th>
                                        <td dangerouslySetInnerHTML={{__html: specification.detail}}></td>
                                    </tr>
                                );
                            }) : ''
                        }
                    </table>
                    <button id="full-spec-button" className="primary mt-3" onClick={() => {window.showSpecModal(i)}} style={{display: tabIdState === i && props.showFullSpecsButton != 'hide' ? 'block' : 'none'}}>Show Full Specs</button>
                </>
            )})}
        </div>
    </div>);
}

export function productDetailPageInit() {
    let galleryImageData = JSON.parse(document.getElementById('gallery_image_data').innerHTML);
    let yt_video_id = JSON.parse(document.getElementById('yt_video_id').innerHTML);
    let galleryRotatingImageData = JSON.parse(document.getElementById('rotating_images').innerHTML);
    let productLabel = JSON.parse(document.getElementById('product_label').innerHTML);
    let showFullSpecsButton = JSON.parse(document.getElementById('show_full_specs_button').innerHTML);
    let materialSpecifications = JSON.parse(document.getElementById('material_specifications').innerHTML);
    let options = JSON.parse(document.getElementById('options').innerHTML);
    let remainingImageCount = document.getElementsByClassName('remaining-images')[0];

    function handleResize () {
        if (!remainingImageCount) {
            return;
        }

        let rotatingImageOffset = 0;

        if (galleryRotatingImageData && galleryRotatingImageData.length > 0) {
            rotatingImageOffset = 1;
        }
        if (window.matchMedia("(max-width: 800px)").matches) {
            remainingImageCount.textContent = (parseInt(galleryImageData.length) - 2 + rotatingImageOffset).toString();
        } else {
            remainingImageCount.textContent = (parseInt(galleryImageData.length) - 3 + rotatingImageOffset).toString();
        }
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    const root = createRoot(document.getElementById('gallery-modal-container')!);
    root.render(<GalleryModal galleryImageData={galleryImageData} galleryRotatingImageData={galleryRotatingImageData} yt_video_id={yt_video_id}></GalleryModal>);

    const productSpecification = createRoot(document.getElementById('product-specification-container')!);
    productSpecification.render(<ProductSpecification materialSpecifications={materialSpecifications} productLabel={productLabel} showFullSpecsButton={showFullSpecsButton}></ProductSpecification>);

    const productSpecificationModal = createRoot(document.getElementById('product-specification-modal')!);
    productSpecificationModal.render(<ProductSpecificationModal maxWidth='640px' materialSpecifications={materialSpecifications} options={options}></ProductSpecificationModal>);

    let miniGalleryImages = document.getElementsByClassName('image-container main');
    const rotatingImage = document.getElementsByClassName('image-container rotate')[0];
    const imageMore = document.getElementsByClassName('image-container more')[0];
    const imageVideo = document.getElementsByClassName('image-container video')[0];

    if (rotatingImage) {
            rotatingImage.addEventListener('click', (e) => {
                const galleryImage = createRoot(document.getElementById('gallery-image')!);
                galleryImage.render(
                    <>
                        <div id="KeyShotXR" ref={() => {
                            if (galleryRotatingImageData && galleryRotatingImageData.length) {
                                initKeyShotXR("KeyShotXR", galleryRotatingImageData[0]['rotating_image']);
                            } else {
                                initKeyShotXR();
                            }
                            document.getElementById("expandButton").addEventListener("click",() => {
                                (window as any).showGalleryModal(true, "rotate");
                            });
                        }}></div>
                    </>
                );
        });
    }

    if (imageMore) {
        imageMore.addEventListener('click', (e) => {
            (window as any).showGalleryModal(true,'image');
        });
    }
    
    if (imageVideo) {
        imageVideo.addEventListener('click', (e) => {
            (window as any).showGalleryModal(true, 'video');
        });
    }

    for (var i=0; i < miniGalleryImages.length; i++) {
        miniGalleryImages[i].addEventListener('click', (e) => {
            let imageDiv = e.currentTarget as HTMLDivElement
            let imageId = parseInt(imageDiv.dataset.imageId);
            const imageElement = document.getElementById('gallery-image')?.getElementsByClassName('image')[0];
            if (imageElement) {
                imageElement.setAttribute('src', getProductGalleryImageById(imageId, galleryImageData).image[0]);
            }
            const captionElement = document.getElementById('gallery-image')?.getElementsByClassName('caption')[0];
            if (captionElement) {
                captionElement.innerHTML = getProductGalleryImageById(imageId, galleryImageData)?.caption;
            }

        });
    }
}

function getProductGalleryImageById(id: Number, product_gallery: Array<any>): any {
    return product_gallery.find(image => image.id === id);
}
